module.exports = __webpack_public_path__ + "assets/img/title-0c237e19.png";